import { useEffectOnce } from '@payaca/hooks';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useSearchParamState = (param: string, initialState: string) => {
  const { search } = useLocation();
  const history = useHistory();

  const allURLSearchParams = useMemo(
    () => new URLSearchParams(search),
    [search]
  );

  const setSearchParam = (value: string) => {
    const newURLSearchParams = new URLSearchParams(search);

    newURLSearchParams.set(param, value);

    history.replace({
      ...history.location,
      search: newURLSearchParams.toString(),
    });
  };

  useEffectOnce(() => {
    // Mount
    const latest = new URLSearchParams(history.location.search);
    setSearchParam(latest.get(param) ?? initialState);

    // Unmount
    return () => {
      const latest = new URLSearchParams(history.location.search);
      latest.delete(param);
      const nextSearch = latest.toString();
      history.replace({
        ...history.location,
        search: nextSearch ?? '',
      });
    };
  });

  return [
    allURLSearchParams.get(param) || initialState,
    setSearchParam,
  ] as const;
};

export default useSearchParamState;
